<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="transparent"
          class="elevation-0 secondary--text mb-4" >
          <v-toolbar-title>Perguntas Frequentes</v-toolbar-title>

          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-expansion-panel
          class="elevation-1">
        <v-expansion-panel-content
          v-for="(faq,index) in faqs"
          :key="index"
        >
          <template v-slot:header>
            <div class="grey--text title">{{faq.titulo}}</div>
          </template>
          <v-card>
            <v-card-text>{{faq.conteudo}}</v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
  </v-container>
</template>

<script>

import { postosDao } from '@/api'

export default {
  data () {
    return {
      faqs: []
    }
  },
  mounted () {
    this.carregarFaqs()
  },
  methods: {
    carregarFaqs () {
      postosDao.getFaqs()
        .then(response => {
          return response.json()
        })
        .then(json => {
          this.faqs = json
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
